import { BUREAU_LABELS } from '../creditBlockClientConstants';

export type ToolbarRequestType = 'lock_request' | 'unlock_request' | 'permanent_unblock' | 'extension';

export const TOOLBAR_FLOW_SHORT_TITLE: Record<ToolbarRequestType, string> = {
  lock_request: 'Block bureaus',
  unlock_request: 'Unblock bureaus',
  permanent_unblock: 'Permanent unblock',
  extension: 'Unblock extension',
};

export function formatToolbarBureauList(bureaus: Array<'equifax' | 'experian' | 'transunion' | 'chexsystems'>): string {
  return bureaus.map((b) => BUREAU_LABELS[b]).join(', ');
}

export function resolveEndDateFromLength(
  startDate: string,
  endLength?: string,
  explicitEndDate?: string
): string | undefined {
  const normalizedStart = String(startDate ?? '').trim();
  if (!normalizedStart) return explicitEndDate || undefined;
  if (endLength === 'custom') return explicitEndDate || undefined;
  const dayOffsets: Record<string, number> = {
    '24_hours': 1,
    '72_hours': 3,
    '7_days': 7,
    '30_days': 30,
  };
  const offsetDays = dayOffsets[String(endLength ?? '').trim()];
  if (!offsetDays) return explicitEndDate || undefined;
  const start = new Date(`${normalizedStart}T00:00:00`);
  if (Number.isNaN(start.getTime())) return explicitEndDate || undefined;
  start.setDate(start.getDate() + offsetDays);
  return start.toISOString().slice(0, 10);
}
